var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "45-Area",
    id: "_45-Area"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,10a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V4H10V2A2,2,0,0,0,8,0H2A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2H4V38H2a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V44H38v2a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2H44V10ZM2,8V2H8V8ZM8,46H2V40H8Zm30-6v2H10V40a2,2,0,0,0-2-2H6V10H8a2,2,0,0,0,2-2V6H38V8a2,2,0,0,0,2,2h2V38H40A2,2,0,0,0,38,40Zm8,0v6H40V40ZM40,8V2h6V8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.7054b91bde72d2375a85a5aa9c04db6f.svg";
export { ForwardRef as ReactComponent };